import { initializeBookingSessionId } from "./booking-session-id";
import { initializeClickTracker } from "./click-tracker";
import { initializeDeferredCss } from "./deferred-css";
import { initializeOneTrustConsent } from "./one-trust-consent";
import { initializeTrafficSourceTracker } from "./traffic-source-tracker";
import "./vetstoria-loader";

initializeDeferredCss();

initializeBookingSessionId();

initializeClickTracker();

initializeTrafficSourceTracker();

initializeOneTrustConsent();
